import { Injector, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PermissionDeniedComponent } from './permission-denied/permission-denied.component';
import { ButtonComponent, FormGridComponent } from 'design-system';
import { LoginComponent } from './login/login.component';
import {
  AlertComponent as oldAlertComponent,
  ButtonComponent as oldButtonComponent,
  FormGridComponent as oldFormGridComponent,
  FormCardComponent as oldFormCardComponent,
  LogoComponent as oldLogoComponent,
  SvgIconComponent as oldSvgIconComponent,
  TextInputComponent as oldTextInputComponent,
  LoginFormComponent,
  MdefLoginFormComponent,
} from 'component-library';
import { AuthenticationConfig } from 'shared';
import { AuthenticationService } from '../config/authentication-service';

@NgModule({
  providers: [],
  imports: [
    PermissionDeniedComponent,
    LoginComponent,
    oldButtonComponent,
    ButtonComponent,
    oldFormGridComponent,
    FormGridComponent,
    CommonModule,
    ReactiveFormsModule,
    oldSvgIconComponent,
    ButtonComponent,
    FormGridComponent,
    oldTextInputComponent,
    oldFormCardComponent,
    oldLogoComponent,
    oldAlertComponent,
    LoginFormComponent,
    MdefLoginFormComponent,
  ],
})
export class AuthenticationModule {
  static forRoot(
    config: AuthenticationConfig,
    authenticationService: Type<AuthenticationService>,
  ): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        { provide: AuthenticationConfig, useValue: config },
        {
          provide: AuthenticationService,
          useFactory: (inj: Injector) => inj.get(authenticationService),
          deps: [Injector],
        },
      ],
    };
  }
}
